/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Sinology13Inputs */

const en__field_enum_study_sinology13 = /** @type {(inputs: _Field_Enum_Study_Sinology13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinology`)
};

const de__field_enum_study_sinology13 = /** @type {(inputs: _Field_Enum_Study_Sinology13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinologie`)
};

/**
* | output |
* | --- |
* | "Sinology" |
*
* @param {_Field_Enum_Study_Sinology13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_sinology13 = /** @type {((inputs?: _Field_Enum_Study_Sinology13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Sinology13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_sinology13(inputs)
	return de__field_enum_study_sinology13(inputs)
});
export { _field_enum_study_sinology13 as "_field_enum_STUDY_SINOLOGY" }